import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useData } from '../data/general/DataContext';
import logo from '../assets/images/logo-1.png';
import {
  TbHome, TbUsers, TbCash, TbBuilding, TbLayoutGrid,
  TbChartBar, TbTruck, TbPackage, TbCar, TbListCheck, TbLogout , TbArchive,
  TbFileInvoice
} from 'react-icons/tb';
import { LuChevronDown, LuChevronLeft } from 'react-icons/lu';
import { IoMdClose } from 'react-icons/io';

function Sidebar() {
  const { sidebarMode, setSidebarMode, windowMode } = useData();
  const navigate = useNavigate();
  const [caseDropdown, setCaseDropdown] = useState(false);
  const [depoDropdown, setDepoDropdown] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (windowMode === 'mobile') setSidebarMode(false);
  }, [currentPath, setSidebarMode, windowMode]);

  const menuItems = [
    { label: 'Dashboard', icon: <TbHome />, path: '/admin/dashboard' },
    { label: 'Servisler', icon: <TbBuilding />, path: '/admin/servisler', section: 'GENERAL' },
    { label: 'Müşteriler', icon: <TbUsers />, path: '/admin/müşteriler', section: 'GENERAL' },
    { label: 'Teklifler', icon: <TbFileInvoice />, path: '/admin/teklif', section: 'GENERAL' },
    { label: 'Bayiler', icon: <TbBuilding />, path: '/admin/bayiler', section: 'GENERAL' },
    { label: 'Personeller', icon: <TbUsers />, path: '/admin/personel', section: 'GENERAL' },
    { label: 'Markalar', icon: <TbBuilding />, path: '/admin/markalar', section: 'OTHER' },
    { label: 'Cihazlar', icon: <TbPackage />, path: '/admin/cihazlar', section: 'OTHER' },
    { label: 'Tedarikçiler', icon: <TbTruck />, path: '/admin/tedarikçiler', section: 'OTHER' },
    { label: 'Araç Kaynak', icon: <TbCar />, path: '/admin/araçlar', section: 'OTHER' },
    { label: 'Aksiyon Türleri', icon: <TbListCheck />, path: '/admin/aksiyon-turleri', section: 'OTHER' },
  ];

  const handleLogout = () => navigate("/girisyap");

  return (
    <div className={`sidebar-container ${windowMode === 'mobile' && sidebarMode ? 'mobile-visible' : ''}`}>
      
      {/* Logo */}
      <div className='sidebar-logo-container'>
        <img src={logo} alt='logo-1' className='sidebar-logo' />
        {windowMode === 'mobile' && sidebarMode && (
          <IoMdClose 
            size={28} 
            color="#000" 
            onClick={() => setSidebarMode(false)} 
            style={{ cursor: 'pointer', position: 'absolute', top: 10, right: 10 }}
          />
        )}
      </div>

      {/* Menü içerik */}
      <div className='sidebar-content-container'>
        <NavLink to='/admin/dashboard' className={`sidebar-content-container-menu-item ${currentPath === '/dashboard' ? 'active' : ''}`}>
          <TbHome />
          <span>Dashboard</span>
        </NavLink>

        <p className='sidebar-content-container-menu-text'>GENERAL</p>
        {menuItems.filter(i => i.section === 'GENERAL').map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={`sidebar-content-container-menu-item ${currentPath === item.path ? 'active' : ''}`}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}

     <p className='sidebar-content-container-menu-text'>PAYMENT</p>
       <NavLink 
  to='/admin/depo' 
  className={`sidebar-content-container-menu-item  ${currentPath === '/depo' ? 'active' : ''}`}
>
  <TbArchive />
  <span className="dropdown-label"><span>Depo</span></span>
</NavLink>
{/* Kasa Dropdown */}
<div className={`sidebar-content-container-menu-dropdown-container ${caseDropdown ? 'open' : ''}`}>
  <button
    className='sidebar-content-container-menu-dropdown'
    onClick={() => setCaseDropdown(!caseDropdown)}
  >
    <span className="dropdown-label"><TbCash /><span>Kasa</span></span>
    <span className="dropdown-icon">{caseDropdown ? <LuChevronDown /> : <LuChevronLeft />}</span>
  </button>
 

  {caseDropdown && (
    <>
      <NavLink to='/admin/kasa' className={`sidebar-content-container-menu-item-2 ${currentPath === '/admin/kasa' ? 'active' : ''}`}>
        <TbCash /><span>Genel</span>
      </NavLink>
     
     
    </>
  )}
</div>



        <p className='sidebar-content-container-menu-text'>OTHER</p>
        {menuItems.filter(i => i.section === 'OTHER').map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={`sidebar-content-container-menu-item ${currentPath === item.path ? 'active' : ''}`}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}

        <div onClick={handleLogout} className="sidebar-content-container-menu-item" style={{ cursor: "pointer" }}>
          <TbLogout />
          <span>Çıkış Yap</span>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
